<template>
    <span
        role="checkbox"
        tabindex="0"
        :aria-checked="modelValue"
        class="relative shrink-0 inline-block h-6 transition-colors duration-200 ease-in-out border-2 border-transparent rounded-full cursor-pointer w-11 focus:outline-none focus:shadow-outline"
        :class="{ 'bg-gray-900': modelValue, 'bg-gray-200': !modelValue }"
        @click="onToggle"
        @keypress.space="onToggle"
    >
        <span
            aria-hidden="true"
            class="inline-block w-5 h-5 transition duration-200 ease-in-out transform translate-x-0 bg-white rounded-full shadow "
            :class="{ 'translate-x-5': modelValue, 'translate-x-0': !modelValue }"
        ></span>
    </span>
</template>

<script>
    export default {
        props: {
            modelValue: {
                required: true,
            },
        },

        methods: {
            onToggle() {
                this.$emit('update:modelValue', !this.modelValue);
                this.$emit('change');
            },
        },
    };
</script>
